import usama from "../../assets/usama.png";
import jonathan from "../../assets/jonathan.png";
import waleed from "../../assets/waleed.png";
import hala from "../../assets/hala.png";
import mohsin from "../../assets/mohsin.png";
import me from "../../assets/home/me.png";

const Hero = () => {
  return (
    <section className="hero section" id="home">
      <div className="hero__container container">
        <div className="hero__content">
          {/* Top Trust Badge */}
          <div className="hero__trust-top">
            <div className="hero__avatars">
              <img src={usama} alt="Founder 1" className="avatar" />
              <img src={jonathan} alt="Founder 2" className="avatar" />
              <img src={waleed} alt="Founder 3" className="avatar" />
              <img src={hala} alt="Founder 4" className="avatar" />
              <img src={mohsin} alt="Founder 5" className="avatar" />
            </div>
            <div className="hero__trust-text">
              Trusted by <span>10+</span>
              <br /> creators and founders.
            </div>
          </div>

          {/* Main Title */}
          <h1 className="hero__title">
            The Home of Premium <br />
            Full-Stack <span className="highlight-text">Engineering</span>
          </h1>

          {/* Subtitle */}
          <p className="hero__subtitle">
            Your <strong>#1 full-stack development</strong> partner. Complete
            engineering covered.
          </p>

          {/* Actions Section */}
          <div className="hero__actions">
            <a
              href="https://cal.com/ahadali/lets-engineer-your-bespoke-product?overlayCalendar=true&layout=month_view"
              target="_blank"
              rel="noreferrer"
              className="hero__cta-booking"
            >
              <div className="hero__cta-faces">
                <img src={me} alt="Ahad Ali" className="hero__cta-avatar" />
                <div className="hero__cta-hover-elements">
                  <span className="hero__cta-plus">+</span>
                  <span className="hero__cta-you">You</span>
                </div>
              </div>
              <span className="hero__cta-text">Book 1-1 Meeting</span>
            </a>

            <span className="hero__actions-text">or DM</span>

            <div className="hero__socials">
              <a
                href="https://wa.me/923241441444"
                target="_blank"
                rel="noreferrer"
                className="hero__social-btn hero__social-wa tooltip"
              >
                <svg
                  className="inner-icon"
                  viewBox="0 0 24 24"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.888-.788-1.489-1.761-1.663-2.06-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
                </svg>
                <span className="tooltip-content tooltip-content--top">
                  Whatsapp
                </span>
              </a>

              <a
                href="https://linkedin.com/in/ahadalireach"
                target="_blank"
                rel="noreferrer"
                className="hero__social-btn hero__social-li tooltip"
              >
                <div className="inner-icon">
                  <svg
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </div>
                <span className="tooltip-content tooltip-content--top">
                  LinkedIn
                </span>
              </a>

              <a
                href="mailto:ahadali.reach@gmail.com"
                target="_blank"
                rel="noreferrer"
                className="hero__social-btn hero__social-em tooltip"
              >
                <svg
                  className="inner-icon"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                <span className="tooltip-content tooltip-content--top">
                  Email
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
